import React, { useEffect, useState } from 'react';
import './availableBenefitsSection.scss';
import { scrollToBlock } from "../../../../components/utils/utilsFunc";
import { ReactComponent as FirstKeyImg } from "./icons/FirstKeyImg.svg";
import { ReactComponent as FirstArrowIcon } from "./icons/FirstArrowIcon.svg";
import { ReactComponent as FirstMoneyImg } from "./icons/FirstMoneyImg.svg";

import { ReactComponent as SecondSuiIcon } from "./icons/SecondSuiIcon.svg";
import { ReactComponent as SecondTronDaoIcon } from "./icons/SecondTronDaoIcon.svg";
import { ReactComponent as SecondBaseIcon } from "./icons/SecondBaseIcon.svg";
import { ReactComponent as SecondBNBChainIcon } from "./icons/SecondBNBChainIcon.svg";
import { ReactComponent as SecondFirstLedgerIcon } from "./icons/SecondFirstLedgerIcon.svg";
import { ReactComponent as SecondApeIcon } from "./icons/SecondApeIcon.svg";
import { ReactComponent as SecondSolanaIcon } from "./icons/SecondSolanaIcon.svg";

import { ReactComponent as SecondSuiAdaptiveIcon } from "./icons/adaptive/SecondSuiAdaptiveIcon.svg";
import { ReactComponent as SecondTronDaoAdaptiveIcon } from "./icons/adaptive/SecondTronDaoAdaptiveIcon.svg";
import { ReactComponent as SecondBaseAdaptiveIcon } from "./icons/adaptive/SecondBaseAdaptiveIcon.svg";
import { ReactComponent as SecondBNBChainAdaptiveIcon } from "./icons/adaptive/SecondBNBChainAdaptiveIcon.svg";
import { ReactComponent as SecondFirstLedgerAdaptiveIcon } from "./icons/adaptive/SecondFirstLedgerAdaptiveIcon.svg";
import { ReactComponent as SecondApeAdaptiveIcon } from "./icons/adaptive/SecondApeAdaptiveIcon.svg";
import { ReactComponent as SecondSolanaAdaptiveIcon } from "./icons/adaptive/SecondSolanaAdaptiveIcon.svg";

import { ReactComponent as ThirdTronTradeIcon } from "./icons/ThirdTronTradeIcon.svg";
import { ReactComponent as ThirdBep20TradeIcon } from "./icons/ThirdBep20TradeIcon.svg";
import { ReactComponent as ThirdBaseTradeIcon } from "./icons/ThirdBaseTradeIcon.svg";
import { ReactComponent as ThirdTitleRobotIcon } from "./icons/ThirdTitleRobotIcon.svg";

const AvailableBenefitsSection = () => {
	const [isHoveredFirst, setIsHoveredFirst] = useState(false);
	const [isHoveredThird, setIsHoveredThird] = useState(false);
	const [password, setPassword] = useState('');
	const [width, setWidth] = useState(window.innerWidth);
	
	const updateDimensions = () => {
		setWidth(window.innerWidth);
	}
	useEffect(() => {
		window.addEventListener("resize", updateDimensions);
		return () => window.removeEventListener("resize", updateDimensions);
	}, []);
	
	useEffect(() => {
			const interval = setInterval(() => {
				setPassword((prev) => (prev.length < (width < 768 ? 20 : 13) ? prev + '•' : ''));
			}, 300);
			
			return () => clearInterval(interval);
	}, [width]);
	
	return (
		<div className="availableBenefits">
			<div className="availableBenefits__content">
				<div className="availableBenefits__content_data">
					<div className="availableBenefits__content_data_title">
						<h3>Get all available benefits</h3>
						<h2>NFD Trade Bots</h2>
						<h2 className="h2_glow">NFD Trade Bots</h2>
						<span>Take advantage{width < 425 && <br/>} of all the features right now</span>
					</div>
					<div className="availableBenefits__content_data_button">
						<button
							className="secondButton"
							onClick={() => scrollToBlock('startTradingNow')}
						>
							<span>Start trading</span>
							<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
								<path d="M1.49915 7.22742C0.946861 7.22742 0.499145 7.67513 0.499145 8.22742C0.499145 8.7797 0.94686 9.22742 1.49915 9.22742L1.49915 7.22742ZM14.6611 8.93452C15.0516 8.544 15.0516 7.91084 14.6611 7.52031L8.29713 1.15635C7.9066 0.765825 7.27344 0.765825 6.88291 1.15635C6.49239 1.54687 6.49239 2.18004 6.88291 2.57056L12.5398 8.22742L6.88291 13.8843C6.49239 14.2748 6.49239 14.908 6.88291 15.2985C7.27344 15.689 7.9066 15.689 8.29713 15.2985L14.6611 8.93452ZM1.49915 9.22742H13.954L13.954 7.22742H1.49915L1.49915 9.22742Z" fill="white"/>
							</svg>
						</button>
					</div>
				</div>
				
				<div className="availableBenefits__content_cards">
					<div className="availableBenefits__content_cards_bg1"></div>
					<div className="availableBenefits__content_cards_bg2"></div>
					
					<div
						className={`availableBenefits__content_cards_item first`}
						onMouseEnter={() => setIsHoveredFirst(true)}
						onMouseLeave={() => setIsHoveredFirst(false)}
					>
						<div className="availableBenefits__content_cards_item_data">
							<h4>Your assets are safe and secure</h4>
							<span>To withdraw money or receive a private key from your wallet, you must enter a password</span>
						</div>
						<div className={`availableBenefits__content_cards_item_animation ${isHoveredFirst ? 'hovered' : ''}`}>
							<div className="availableBenefits__content_cards_item_animation_icons">
								<FirstKeyImg />
								<FirstArrowIcon />
								<FirstMoneyImg />
							</div>
							
							<div className="availableBenefits__content_cards_item_animation_bg1"></div>
							<div className="availableBenefits__content_cards_item_animation_bg2"></div>
							<div className="availableBenefits__content_cards_item_animation_bg3"></div>
							
							<div className="availableBenefits__content_cards_item_animation_input">
								<span>Your private password:</span>
								<input type="text" value={password} readOnly/>
								<div className="input_glow"></div>
							</div>
						</div>
					</div>
					<div className="availableBenefits__content_cards_item second">
						<div className="availableBenefits__content_cards_item_data">
							<h4>Speed<br/>and usability</h4>
							<span>Experience all the benefits of speed and convenience</span>
						</div>
						<div className="availableBenefits__content_cards_item_cards">
							<div className="availableBenefits__content_cards_item_cards_item first">
								<ThirdTronTradeIcon />
								<div className="availableBenefits__content_cards_item_cards_item_data">
									<div className="availableBenefits__content_cards_item_cards_item_data_title">
										<ThirdTitleRobotIcon />
										<p>NFD Tron Trade...</p>
									</div>
									<span>Welcome to TronBot...</span>
								</div>
							</div>
							<div className="availableBenefits__content_cards_item_cards_item second">
								<ThirdBep20TradeIcon />
								<div className="availableBenefits__content_cards_item_cards_item_data">
									<div className="availableBenefits__content_cards_item_cards_item_data_title">
										<ThirdTitleRobotIcon />
										<p>NFD BEP20 Trade...</p>
									</div>
									<span>Welcome to BscBot...</span>
								</div>
							</div>
							<div className="availableBenefits__content_cards_item_cards_item third">
								<ThirdBaseTradeIcon />
								<div className="availableBenefits__content_cards_item_cards_item_data">
									<div className="availableBenefits__content_cards_item_cards_item_data_title">
										<ThirdTitleRobotIcon />
										<p>NFD Base Trade...</p>
									</div>
									<span>Welcome to BaseBot...</span>
								</div>
							</div>
						</div>
					</div>
					<div
						className="availableBenefits__content_cards_item third"
						onMouseEnter={() => setIsHoveredThird(true)}
						onMouseLeave={() => setIsHoveredThird(false)}
					>
						<div className="availableBenefits__content_cards_item_data">
							<h4>Buy. Sell. Earn.</h4>
						</div>
						{
							width > 767 ? (
								<div className={`availableBenefits__content_cards_item_animation hovered`}>
									<SecondSuiIcon />
									<SecondTronDaoIcon />
									<SecondBaseIcon />
									<SecondBNBChainIcon />
									<SecondFirstLedgerIcon />
									<SecondApeIcon />
									<SecondSolanaIcon />
								</div>
							) : (
								<div className={`availableBenefits__content_cards_item_animation hovered`}>
									<SecondSuiAdaptiveIcon />
									<SecondTronDaoAdaptiveIcon />
									<SecondBaseAdaptiveIcon />
									<SecondBNBChainAdaptiveIcon />
									<SecondFirstLedgerAdaptiveIcon />
									<SecondApeAdaptiveIcon />
									<SecondSolanaAdaptiveIcon />
								</div>
							)
						}
					</div>
				</div>
			</div>
		</div>
	);
};

export default AvailableBenefitsSection;